import * as React from 'react';

function Radio (): JSX.Element {
    return (
        <span>我觉得挺牛逼的</span>
    )
}

export default Radio
